<mat-toolbar class="header shadow2">
  <mat-toolbar-row class="shadow2">
    <a routerLink="home" class="brand cursor-pointer">
      <div style="display:flex;">
        <img src="../../assets/images/logo.svg" alt="skf logo" class="logo" /><br>
        <img class="app-logo" src="{{ appLogos[appName] }}" alt="App Logo" />
      </div>
    </a>
  </mat-toolbar-row>
</mat-toolbar>